import React, { useRef } from "react";
import { Form, Input, Row, Col, Modal } from "antd";
import { connect } from "dva";
import { StoreState } from "@src/interfaces";
import Loading from "@src/components/Loading";
import {
  StyledForm,
  LoadingOverlay,
  StyledTabsContainer,
  FormContainer,
  StyledTabs,
} from "./styles";
import TabPane from "antd/lib/tabs";
import { useHistory } from "react-router-dom";
import { useProductForm } from "./hooks/useProductForm";
import ProductDetailsSection from "./components/ProductDetailsSection";
import FormActions from "./components/FormActions";
import BasicInfoSection from "./components/BasicInfoSection";
import ShippingSection from "./components/ShippingSection";

interface CreateProductFormCtrlProps {
  authUser?: any;
  query?: any;
  dispatch?: any;
}

const CreateProductFormCtrl: React.FC<CreateProductFormCtrlProps> = (props) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const basicInfoRef = useRef<HTMLDivElement>(null);
  const productDetailsRef = useRef<HTMLDivElement>(null);
  const shippingRef = useRef<HTMLDivElement>(null);

  const {
    loading,
    variations,
    combinations,
    activeTab,
    isAtBottom,
    useVariationShipping,
    product,
    init,
    setActiveTab,
    setUseVariationShipping,
    onFinish,
    addVariation,
    removeVariation,
    handleVariationNameChange,
    removeOption,
    handleOptionChange,
    handleOptionKeyPress,
    handleDragStart,
    handleDragOver,
    handleDrop,
    handleCombinationChange,
    applyToAll,
  } = useProductForm(props.query);

  const handleSave = (isShow: boolean) => {
    Modal.confirm({
      title: "Xác nhận",
      content: isShow
        ? "Bạn có chắc chắn muốn lưu và hiển thị sản phẩm này?"
        : "Bạn có chắc chắn muốn lưu và ẩn sản phẩm này?",
      okText: "Yes",
      cancelText: "No",
      onOk: () => {
        form.setFieldsValue({
          isActive: isShow,
          isApprove: isShow,
        });
        form.validateFields().then(() => {
          form.submit();
        });
      },
    });
  };

  const scrollToSection = (key: string) => {
    const refs: { [key: string]: React.RefObject<HTMLDivElement> } = {
      "1": basicInfoRef,
      "2": productDetailsRef,
      "3": shippingRef,
    };

    const ref = refs[key];
    ref?.current?.scrollIntoView({ behavior: "smooth" });
    setActiveTab(key);
  };

  if (!init) return <Loading />;

  return (
    <StyledForm
      form={form}
      name="create_product_form"
      onFinish={onFinish}
      layout="horizontal"
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 18 }}
      initialValues={{
        isActive: false,
        isApprove: false,
      }}
    >
      {loading && <LoadingOverlay />}

      <Row gutter={24}>
        <Col span={24}>
          <StyledTabsContainer>
            <StyledTabs activeKey={activeTab} onChange={scrollToSection}>
              <TabPane tab="Thông tin cơ bản" key="1" />
              <TabPane tab="Chi tiết sản phẩm" key="2" />
              <TabPane tab="Vận chuyển" key="3" />
            </StyledTabs>
          </StyledTabsContainer>

          <FormContainer>
            <BasicInfoSection
              basicInfoRef={basicInfoRef}
              form={form}
              product={product}
            />

            <ProductDetailsSection
              productDetailsRef={productDetailsRef}
              variations={variations}
              combinations={combinations}
              useVariationShipping={useVariationShipping}
              onAddVariation={addVariation}
              onRemoveVariation={removeVariation}
              onVariationNameChange={handleVariationNameChange}
              onOptionChange={handleOptionChange}
              onOptionKeyPress={handleOptionKeyPress}
              onRemoveOption={removeOption}
              onDragStart={handleDragStart}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
              onCombinationChange={handleCombinationChange}
              onApplyToAll={applyToAll}
              isEditing={!!props.query?.id}
            />

            <ShippingSection
              shippingRef={shippingRef}
              useVariationShipping={useVariationShipping}
              onVariationShippingChange={setUseVariationShipping}
            />
          </FormContainer>

          <Form.Item name="isActive" hidden>
            <Input type="hidden" />
          </Form.Item>
          <Form.Item name="isApprove" hidden>
            <Input type="hidden" />
          </Form.Item>
        </Col>
      </Row>

      <FormActions
        isAtBottom={isAtBottom}
        onCancel={() => history.goBack()}
        onSaveAndHide={() => handleSave(false)}
        onSaveAndShow={() => handleSave(true)}
      />
    </StyledForm>
  );
};

const mapStateToProps = ({ auth }: StoreState) => ({
  authUser: auth.authUser,
});

export default connect(mapStateToProps)(CreateProductFormCtrl);
